<svelte:head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <meta name="description" content="">
  <meta name="author" content="">

  <!-- Bootstrap core CSS -->
  <link href="/Java/vendor/blog/bootstrap/css/bootstrap.min.css" rel="stylesheet">

  <!-- Custom fonts for this template -->
  <link href="/Java/vendor/blog/fontawesome-free/css/all.min.css" rel="stylesheet" type="text/css">
  <link href='https://fonts.googleapis.com/css?family=Lora:400,700,400italic,700italic' rel='stylesheet' type='text/css'>
  <link href='https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,700italic,800italic,400,300,600,700,800' rel='stylesheet' type='text/css'>

  <!-- Custom styles for this template -->
  <link href="/Java/css/blog/clean-blog.min.css" rel="stylesheet">
  <link href="/Java/css/blog/custom.css" rel="stylesheet">
  <link href="/Java/css/comming/coming-soon.css" rel="stylesheet">
  <link href="/Java/css/comming/coming-soon.min.css" rel="stylesheet">

    <!-- Bootstrap core JavaScript -->
  <script src="/Java/vendor/comming/jquery/jquery.min.js"></script>
  <script src="/Java/vendor/comming/bootstrap/js/bootstrap.bundle.min.js"></script>
  <title>Preparing Blog</title>
</svelte:head>

<body>
  <div class="overlay"></div>
  <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
    <source src="/Java/mp4/bg.mp4" type="video/mp4">
  </video>

  <div class="masthead">
    <div class="masthead-bg"></div>
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-12 my-auto">
          <div class="masthead-content text-white py-5 py-md-0">
            <h1 class="mb-3">준비 중 입니다!</h1>
            <p class="mb-5">함수형 프로그래밍 언어인 <strong>Golang</strong> 으로 작성된 블로그를 <strong>Java</strong> 로 리빌딩 중 입니다.</p>
            <p class="mb-5"><strong>Golang</strong> Website Convert To <strong>Java</strong> Website</p>
            <p class="mb-5">Front-End : jsp, Bootstrap Template
            	<br>Back-End : Java, mybatis, MySQL, Spring Boot
            </p>
            <p></p>
            <div class="input-group input-group-newsletter">
	            <form method="POST" action="http://localhost:8080/login">
		            <input name="id" class="form-control" placeholder="Input ID..." aria-label="Input ID..." aria-discribedby="submit-button">
		            <input name="pw" type="password" class="form-control" placeholder="Input PW..." aria-label="Input PW..." aria-discribedby="submit-button">
		            <input class="btn btn-secondary" type="submit" id="submit-button" value="관리자 접속">
	            </form>
            </div>
            <!--
             <div class="input-group input-group-newsletter">
              <input type="email" class="form-control" placeholder="Enter email..." aria-label="Enter email..." aria-describedby="submit-button">
              <div class="input-group-append">
                <button class="btn btn-secondary" type="button" id="submit-button">Notify Me!</button>
              </div>
            </div>
             -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="social-icons">
    <ul class="list-unstyled text-center mb-0">
      <li class="list-unstyled-item">
        <a href="mailto:rodvkf72@naver.com">
          <i class="fas fa-envelope"></i>
        </a>
      </li>
      <li class="list-unstyled-item">
        <a href="https://github.com/rodvkf72">
          <i class="fab fa-github"></i>
        </a>
      </li>
    </ul>
  </div>

</body>
